import checkout from "./form2";

const {
  formField2: {
    period,
    firstTime,
    additional,

    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues2 = {
  [period.name]: "",
  [firstTime.name]: "",
  [additional.name]: "",

  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues2;
